import './style.scss';

import React from 'react';
import scrollIntoView from 'scroll-into-view';
import SideNav from '../../sideNav';
import Login from '../../header/login';
import ValueProps from './valueProps';
import Media from './media';
import Address from './address';
import FAQ from './faq';
import Categories from './categories';
import Footer from '../../footer';
import * as Card from '../../ui/card';
import Typewriter from '../../ui/typewriter';
import SauceyLogo from 'images/saucey.svg';
import { AsyncLeadCaptureModal } from 'components/async';

export default class HomeLandingPage extends React.Component {
  constructor(props) {
    super(props);
    this.scrollToValueProps = this.scrollToValueProps.bind(this);
    this.typewriterStrings = [
      'wine is better from your sofa',
      'no good story ever started with a salad',
      'your mother-in-law is coming over',
      'you deserve it',
      'you brunch like a bawss',
      "it's date night at the house",
      "you're Saucey AF",
      'a party without alcohol is just a meeting',
      "tequila is gluten-free... so that's fun"
    ];
  }

  scrollToValueProps(e) {
    e.preventDefault();
    const valuePropsSection = document.getElementById('value-props');
    scrollIntoView(valuePropsSection, { align: { top: 0, topOffset: -10 } });
  }

  render() {
    return (
      <div className="home--landing-page">
        <main id="panel" className="panel slideout-panel">
          <nav className="row center-xs start-md middle-xs home--landing-page__header">
            <div className="hidden-md js-slideout-toggle">
              <i className="icon-hamburger" />
            </div>
            <div className="col-xs">
              <img className="nav-logo" src={SauceyLogo} />
              <a
                className="visible-md-inline"
                href="#value-props"
                onClick={this.scrollToValueProps}
              >
                How It Works
              </a>
            </div>
            <div className="col-md-4 visible-md-inline">
              <Login />
            </div>
          </nav>

          <section className="landing-page-section landing-page-section--hero">
            <div className="landing-page-section--hero__container">
              <h1 className="landing-page-section--hero__heading">
                Alcohol Delivery
              </h1>
              <h2 className="landing-page-section--hero__subheading">
                <span>Because </span>
                <span className="home--landing-page__typewriter-container">
                  <Typewriter
                    id="typewriter1"
                    strings={this.typewriterStrings}
                    typeSpeed={90}
                    backSpeed={50}
                    loop={true}
                  />
                </span>
              </h2>
              <div className="cta-container">
                <Address
                  scrollOnSubmit
                  trackingParams={{ page: 'Homepage', source: 'Homepage Hero' }}
                />
              </div>
            </div>
          </section>

          <section
            id="value-props"
            className="landing-page-section landing-page-section--value-props"
          >
            <div className="landing-page-section__container landing-page-section--value-props__container">
              <ValueProps />
            </div>
          </section>

          <section className="landing-page-section landing-page-section--media">
            <div className="landing-page-section__container">
              <Media />
            </div>
          </section>

          <section className="landing-page-section landing-page-section--categories">
            <div className="landing-page-section__container">
              <Categories />
            </div>
          </section>

          <section className="landing-page-section landing-page-section--testimonials">
            <div className="landing-page-section__container landing-page-section--testimonials__container">
              <h2 className="landing-page-section__heading">People Love Us</h2>
              <div className="row around-sm">
                <div className="col-xs-12 col-sm-4">
                  <Card.Container>
                    <Card.Image className="testimonial-image testimonial-image--left" />
                    <Card.Text>
                      <blockquote>
                        <p className="text-emphasized">
                          {'"'}Convenience at its finest.{'"'}
                        </p>
                        <footer>– Yashira J.</footer>
                      </blockquote>
                    </Card.Text>
                  </Card.Container>
                </div>
                <div className="col-xs-12 col-sm-4">
                  <Card.Container>
                    <Card.Image className="testimonial-image testimonial-image--center" />
                    <Card.Text>
                      <blockquote>
                        <p className="quote text-emphasized">
                          {'"'}Dangerously good because just when I thought I
                          couldn{"'"}t get any lazier, I can now have everything
                          delivered to my front door!{'"'}
                        </p>
                        <footer>– Rio S.</footer>
                      </blockquote>
                    </Card.Text>
                  </Card.Container>
                </div>
                <div className="col-xs-12 col-sm-4">
                  <Card.Container>
                    <Card.Image className="testimonial-image testimonial-image--right" />
                    <Card.Text>
                      <blockquote>
                        <p className="quote text-emphasized">
                          {'"'}As a beer enthusiast, this app is amazing.{'"'}
                        </p>
                        <footer>– Miguel I.</footer>
                      </blockquote>
                    </Card.Text>
                  </Card.Container>
                </div>
              </div>
            </div>
          </section>

          <section className="landing-page-section landing-page-section--secondary-cta">
            <h2 className="landing-page-section__heading landing-page-section--secondary-cta__heading">
              Saucey territories
            </h2>
            <div className="landing-page-section--secondary-cta__container">
              <h2 className="landing-page-section--secondary-cta__subheading">
                On-demand 30-min delivery or 2-day shipping
              </h2>
              <hr className="landing-page-section--secondary-cta__separator" />
              <p className="landing-page-section--secondary-cta__text">
                Enter your zip code to see your delivery options
              </p>
              <div className="cta-container">
                <Address
                  scrollOnSubmit
                  customId="address-input-secondary"
                  trackingParams={{
                    page: 'Homepage',
                    source: 'Homepage Secondary'
                  }}
                />
              </div>
            </div>
          </section>

          <section className="landing-page-section landing-page-section--faq">
            <h2 className="landing-page-section__heading">FAQ</h2>
            <FAQ />
          </section>

          <Footer />
          <AsyncLeadCaptureModal />
        </main>
        <SideNav />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/components/home/landingPage/index.js